import 'css-chunksrc/client/scenes/projectCreationForm/projectPortfoliosList/portfolioAssignation/projectPortfolio/styles.scss';export default {
  "projectPortfolio": "_projectPortfolio_4m8j0_1"
};